(function () {
  const MODULE_SELECTOR = '[data-module="cart-recommendations-slider"]';
  const sliderInstances = new WeakMap();

  /**
   * @returns {any}
   */
  function getSwiperConstructor() {
    return /** @type {any} */ (window).Swiper;
  }

  /**
   * @param {Element} module
   */
  function destroyModuleInstance(module) {
    const instance = sliderInstances.get(module);
    if (instance && typeof instance.destroy === "function") {
      instance.destroy(true, true);
    }
    sliderInstances.delete(module);
  }

  /**
   * @param {Element} module
   */
  function initModule(module) {
    if (!(module instanceof Element)) return;

    const swiperEl = module.querySelector(".swiper");
    const paginationEl = module.querySelector(".swiper-pagination");
    if (!swiperEl || !paginationEl) return;

    const SwiperConstructor = getSwiperConstructor();
    if (!SwiperConstructor) return;

    destroyModuleInstance(module);

    sliderInstances.set(
      module,
      new SwiperConstructor(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      })
    );
  }

  /**
   * @param {Element | Document | undefined} [root]
   */
  function initAll(root) {
    const scope =
      root instanceof Element || root instanceof Document ? root : document;

    const modules =
      scope instanceof Element && scope.matches(MODULE_SELECTOR)
        ? [scope]
        : Array.from(scope.querySelectorAll(MODULE_SELECTOR));

    modules.forEach(initModule);
  }

  /**
   * @param {Element | Document | undefined} [root]
   */
  function scheduleInit(root) {
    requestAnimationFrame(() => initAll(root));
  }

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("cart:update", () => scheduleInit());
  document.addEventListener("cart-drawer:rendered", () => initAll());
  document.addEventListener(
    "cart-recommendations:rendered",
    /**
     * @param {CustomEvent<{ sectionId?: string; root?: Element }>} event
     */
    (event) => {
      const root = event.detail?.root || event.target;
      scheduleInit(root instanceof Element ? root : undefined);
    }
  );

  class CartRecommendationsSlider {
    /**
     * @param {Element | Document | undefined} [root]
     */
    constructor(root) {
      initAll(root);
    }

    /**
     * @param {Element | Document | undefined} [root]
     */
    static init(root) {
      initAll(root);
    }
  }

  /** @type {any} */ (window).CartRecommendationsSlider =
    CartRecommendationsSlider;
})();
